export default {
  name: "MyDivider"
};